module.exports = __webpack_public_path__ + "img/notifications_new_info.cfe7d5e0.svg";